<template lang="pug">
    v-list-tile-content.wf-space-between.wf-align-items-center.mt-2(
    )
      v-flex
        span {{ label }}
        v-tooltip(
          v-if="labelTooltip"
          top
          :max-width="maxWidth"
        )
          template(v-slot:activator="{ on }")
            v-icon.ml-1.tooltip(
              v-on="on"
              small
            ) help_outline
          span {{ labelTooltip }}
      v-flex.text-xs-right
        span {{ value }}
        v-tooltip(
          v-if="valueTooltip"
          top
        )
          template(v-slot:activator="{ on }")
            v-icon.ml-1.tooltip(
              v-on="on"
              small
            ) help_outline
          span {{ valueTooltip }}
</template>

<script>
  export default {
    name: 'LabelValueTile',
    props: {
      label: {
        type: String,
        default: ''
      },
      value: {
        type: String,
        default: ''
      },
      labelTooltip: {
        type: String,
        default: null,
      },
      valueTooltip: {
        type: String,
        default: null,
      },
      maxWidth: {
        type: String,
        default: null,
      }
    }
  }
</script>

<style scoped>
  .tooltip {
    vertical-align: middle;
    font-size: 20px;
  }
</style>
